module.exports = __webpack_public_path__ + "media/images/calendar-zoom-5b7e5c4d.png";